import { render, staticRenderFns } from "./join-success.vue?vue&type=template&id=902bf9be"
import script from "./join-success.vue?vue&type=script&lang=ts"
export * from "./join-success.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports